// extracted by mini-css-extract-plugin
module.exports = {"dropdownArrow":"DropdownNew_dropdownArrow__p2E6o"};